import { useEffect, useState } from 'react';
import { Box, Button, Grid, Typography } from "@mui/material";
import { ServiceCategory, ServiceItem } from 'orderme-api-integration-client';
import { appStyleMode } from '../../helpers/clientConfigs';
import { BreadcrumbsBar } from '../breadcrumbs/breadcrumbsBar';
import { useTranslation } from 'react-i18next';
import { GoodsRoute } from '../../routes/allRoutes';
import { useRouteNavigator } from '../../routes/useRouteNavigator';
import { ServiceClient } from '../../helpers/client';
import { roundDoubleNumbers } from '../../helpers/currency';
import { addToCart } from '../../redux/reducers/cartReducer';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { AppStyle } from '../../helpers/appStyle';
import { getUserId } from '../../helpers/customerHelper';
import { GoodsItemImage } from './goodsItemImage';
import { Linear } from '../progressBars/linear';
import { EmptyGoodsList } from './emptyGoodsList';
import { RootState } from '../../redux/store';

export function GoodsList() {
    const [goods, setGoods] = useState<ServiceItem[]>();
    const servicesClient = new ServiceClient();
    const { t } = useTranslation();
    const routeNavigator = useRouteNavigator();
    const dispatch = useAppDispatch();
    const goodsCategory: ServiceCategory = useAppSelector((state: RootState) => state.categoriesState.goodsCategory);

    useEffect(() => {
        fetchGoods();
    }, []);

    const fetchGoods = async () => {
        try {
            const serviceItems = await servicesClient.getServiceItems(getUserId());
            setGoods(serviceItems);
        } catch (error) {
            console.error('Error fetching goods:', error);
        }
    };

    const openGoodsItem = (goodsItem: ServiceItem) => {
        routeNavigator.goToGoodsItem(goodsItem);
    }

    const addProductToCart = (service: ServiceItem) => {
        dispatch(addToCart(service));
    }

    return (
        <Box sx={{}} className={appStyleMode === AppStyle.Mobile && "goods-list"}>
            <BreadcrumbsBar paths={[{ path: GoodsRoute, title: goodsCategory?.name }]} />
            {!goods && (
                <Box
                    sx={{
                        height: "600px",
                        display: "flex",
                        justifyContent: "center",
                        backgroundColor: "white",
                        borderRadius: "15px",
                        pt: "10px"
                    }}
                >
                    <Linear />
                </Box>
            )}
            {goods &&
                (goods.length === 0 ?
                    <EmptyGoodsList /> :
                    <Grid container
                        sx={{
                            px: "10px",
                            width: "auto",
                            pb: "20px",
                            backgroundColor: "white",
                            borderRadius: "15px",
                            py: "10px",
                            color: "black"
                        }}>

                        {goods.map((item, index) => (
                            <Grid sx={{ px: "5px", pb: "20px" }} item xs={12} sm={6} md={4} lg={3} key={index}>
                                <Grid container flexDirection="column" sx={{ height: "100%" }}>
                                    <Box
                                        sx={{
                                            maxHeight: "300px",
                                            '&:hover': {
                                                cursor: item.logoId && "pointer",
                                            },
                                        }}
                                        onClick={() => openGoodsItem(item)}>
                                        {item.logoId && <GoodsItemImage service={item} />}
                                    </Box>
                                    <Box sx={{ textAlign: "center" }}>
                                        <Typography
                                            sx={{
                                                '&:hover': {
                                                    cursor: "pointer",
                                                }
                                            }}
                                            onClick={() => openGoodsItem(item)}>
                                            {item.name}
                                        </Typography>
                                        <Grid container justifyContent="center">
                                            <Typography
                                                sx={{
                                                    opacity: 0.7,
                                                    textDecoration: "line-through",
                                                    pr: "10px",
                                                    display: item.originalPrice - item.price === 0 ? "none" : "inline-block"
                                                }}>
                                                {roundDoubleNumbers(item.originalPrice)} €
                                            </Typography>
                                            <Typography> {roundDoubleNumbers(item.price)} €</Typography>
                                        </Grid>
                                    </Box>
                                    <Box sx={{ mt: "auto", textAlign: "center" }}>
                                        <Button onClick={() => addProductToCart(item)}>{t('payment:addToCart')}</Button>
                                    </Box>
                                </Grid>
                            </Grid>
                        ))}
                    </Grid>
                )}
        </Box>
    );
}